import { createFileRoute } from '@tanstack/react-router'
import { auditSearchSchema } from '@/features/audit/lib/audit-search'
import { AdminAuditPage } from '@/features/audit/pages/admin-audit-page'

export const Route = createFileRoute('/audit')({
  staticData: { title: 'Audit Logs' },
  validateSearch: (search) => auditSearchSchema.parse(search),
  component: AdminAuditPage,
})
